<nav class="sidebar-nav">
  <ul>
    <ng-container *ngFor="let option of filteredSidebar; trackBy: trackByLabel">
      <li>

        <!-- MAIN MENU WITHOUT CHILD -->
        <a *ngIf="!option.subMenu?.length"
           class="menu-link"
           [routerLink]="option.route">
          <i [class]="option.icon"></i>
          <span class="hide-menu">{{ option.label }}</span>
        </a>

        <!-- MAIN MENU WITH CHILD -->
        <div *ngIf="option.subMenu?.length">
          <a class="menu-link menu-arrow"
             [class.open]="showMenu === option.label"
             (click)="toggleMenu(option.label)">
            <i [class]="option.icon"></i>
            <span class="hide-menu">{{ option.label }}</span>
          </a>

          <!-- LEVEL 1 SUBMENU -->
          <ul class="collapse" [class.show]="showMenu === option.label">
            <ng-container *ngFor="let menu of option.subMenu; trackBy: trackByLabel">
              <li>

                <!-- LEVEL 1 MENU WITH CHILD -->
                <a *ngIf="menu.subMenu?.length"
                   class="menu-link menu-arrow level-1"
                   [class.open]="showSubMenu === menu.label"
                   (click)="toggleSubMenu(menu.label)">
                  <i [class]="menu.icon"></i>
                  <span class="hide-menu">{{ menu.label }}</span>
                </a>

                <!-- LEVEL 1 LEAF -->
                <a *ngIf="!menu.subMenu?.length"
                   class="menu-link level-1"
                   [routerLink]="menu.route"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{ exact: true }">
                  <i [class]="menu.icon"></i>
                  <span class="hide-menu">{{ menu.label }}</span>
                </a>

                <!-- LEVEL 2 LEAFS -->
                <ul class="collapse" [class.show]="showSubMenu === menu.label">
                  <li *ngFor="let subMenu of menu.subMenu; trackBy: trackByLabel"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link level-2" [routerLink]="subMenu.route">
                      <i [class]="subMenu.icon"></i>
                      <span class="hide-menu">{{ subMenu.label }}</span>
                    </a>
                  </li>
                </ul>

              </li>
            </ng-container>
          </ul>
        </div>

      </li>
    </ng-container>
  </ul>
</nav>
